<template>
  <div class="danger tw-mx-5" v-if="isOpen">
    <span class="mx-3">
      เอกสารที่ไม่มีไฟล์
      {{`${docEmptyXmlUrlList.length ? `xml ${docEmptyXmlUrlList.length} ฉบับ` : ''} ${docEmptyPdfUrlList.length > 0 ? `pdf ${docEmptyPdfUrlList.length} ฉบับ`: ''}`}}
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <u class="ml-2" v-bind="attrs" v-on="on">
            <b>เรียกดูเอกสารนั้น</b>
          </u>
        </template>
        <div>
          <div class="text-center" v-if="docEmptyXmlUrlList.length> 0"><b>XML</b></div>
          <div v-for="xml in docEmptyXmlUrlList" :key="'xml_' + xml">{{ xml }}</div>
          <div class="text-center" v-if="docEmptyPdfUrlList.length> 0"><b>PDF</b></div>
          <div v-for="pdf in docEmptyPdfUrlList" :key="'pdf_' + pdf">{{ pdf }}</div>
        </div>
      </v-tooltip>
    </span>
    <v-icon color="#fff" class="mx-2" @click="isOpen = false">mdi-close-circle-outline</v-icon>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: 'AlertEmptyFile',
  computed: mapState({
    selectedList: state => state.docs.selectedList,
  }),
  data() {
    return {
      isOpen: false,
      docEmptyXmlUrlList: [],
      docEmptyPdfUrlList: [],
    }
  },
  methods: {},
  watch: {
    selectedList: {
      handler: function (selectedList) {
        this.docEmptyXmlUrlList = []
        this.docEmptyPdfUrlList = []
        selectedList.forEach((select) => {
          if (!select['xmlUrl']) {
            this.docEmptyXmlUrlList.push(select.docID)
          }
          if (!select['pdfUrl']) {
            this.docEmptyPdfUrlList.push(select.docID)
          }
        })

        this.isOpen = this.docEmptyXmlUrlList.length > 0 || this.docEmptyPdfUrlList.length > 0;
      }
    },
  },
}
</script>

<style lang="scss">
.danger {
  min-width: 450px;
  height: 40px;
  background-color: #c9242b;
  position: absolute;
  border-radius: 0 0 15px 15px !important;
  color: #ffffff;
  display: flex;
  align-items: center;
  font-size: 16px;
  left: 258px;

  @media only screen and (max-width: 700px) {
    border-radius: 10px;
  }
}

.v-card > *:last-child:not(.v-btn):not(.v-chip) {
  border-bottom-left-radius: 24px;
  border-bottom-right-radius: 0;

  @media only screen and (max-width: 700px) {
    border-radius: 10px;
  }

}
</style>
